// @ts-nocheck — W8.2: PublicLayout migrado do container legado (antd Layout) para Mantine AppShell
import React from "react";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  AppShell,
  Group,
  NavLink,
  Text,
  Box,
  Tabs,
  Image,
  Stack,
} from "@mantine/core";
import { IconMap, IconRoad, IconFiles, IconFolderOpen } from "@tabler/icons-react";

import * as containerAction from "../actions/Container";

function PublicHeader() {
  const config = useSelector((state: any) => state.container.config);
  const publicSettings = useSelector((state: any) => state.publicSettings.settings);
  const location = useLocation();
  const navigate = useNavigate();

  if (!config || !publicSettings) return null;

  const {
    navegadorGeofinanceiroActive,
    logradouroActive,
    arquivosDigitalizadosActive,
    arquivosGeraisActive,
    navegadorGeofinanceiroAbaName,
    logradouroAbaName,
    arquivosDigitalizadosAbaName,
    arquivosGeraisAbaName,
    opcaoExibicaoMenu,
  } = publicSettings;

  const apiUrl = import.meta.env.REACT_APP_API_URL ?? "";
  const logoUrl = apiUrl.replace(/\/api$/, "") + "/api/PublicConfig/DownloadSystemLogoInit";

  const getActiveTab = () => {
    const p = location.pathname;
    if (p.startsWith("/navegador-geofinanceiro") || p === "/") return "/navegador-geofinanceiro";
    if (p.startsWith("/logradouro")) return "/logradouro";
    if (p.startsWith("/arquivos-digitalizados")) return "/arquivos-digitalizados";
    if (p.startsWith("/arquivos-gerais-financas")) return "/arquivos-gerais-financas";
    return "/navegador-geofinanceiro";
  };

  return (
    <AppShell.Header p="xs" style={{ display: "flex", alignItems: "center", gap: 16 }}>
      <Link to="/" style={{ display: "flex", alignItems: "center", textDecoration: "none" }}>
        <img src={logoUrl} alt={config.systemName} style={{ height: 36, objectFit: "contain" }} />
      </Link>

      {opcaoExibicaoMenu === "[ABA]" && (
        <Tabs
          value={getActiveTab()}
          onChange={(v) => v && navigate(v)}
          style={{ flex: 1 }}
          variant="pills"
        >
          <Tabs.List>
            {navegadorGeofinanceiroActive && (
              <Tabs.Tab value="/navegador-geofinanceiro" leftSection={<IconMap size={14} />}>
                {navegadorGeofinanceiroAbaName || "Navegador"}
              </Tabs.Tab>
            )}
            {logradouroActive && (
              <Tabs.Tab value="/logradouro" leftSection={<IconRoad size={14} />}>
                {logradouroAbaName || "Logradouros"}
              </Tabs.Tab>
            )}
            {arquivosDigitalizadosActive && (
              <Tabs.Tab value="/arquivos-digitalizados" leftSection={<IconFiles size={14} />}>
                {arquivosDigitalizadosAbaName || "Arquivos Digitalizados"}
              </Tabs.Tab>
            )}
            {arquivosGeraisActive && (
              <Tabs.Tab value="/arquivos-gerais-financas" leftSection={<IconFolderOpen size={14} />}>
                {arquivosGeraisAbaName || "Arquivos Gerais"}
              </Tabs.Tab>
            )}
          </Tabs.List>
        </Tabs>
      )}
    </AppShell.Header>
  );
}

function PublicNavbar() {
  const config = useSelector((state: any) => state.container.config);
  const publicSettings = useSelector((state: any) => state.publicSettings.settings);
  const location = useLocation();

  if (!config || !publicSettings) return null;

  const {
    navegadorGeofinanceiroActive,
    logradouroActive,
    arquivosDigitalizadosActive,
    arquivosGeraisActive,
    navegadorGeofinanceiroAbaName,
    logradouroAbaName,
    arquivosDigitalizadosAbaName,
    arquivosGeraisAbaName,
    opcaoExibicaoMenu,
  } = publicSettings;

  if (opcaoExibicaoMenu !== "[LATERAL]") return null;

  const apiUrl = import.meta.env.REACT_APP_API_URL ?? "";
  const logoUrl = apiUrl.replace(/\/api$/, "") + "/api/PublicConfig/DownloadSystemLogoInit";
  const p = location.pathname;

  return (
    <AppShell.Navbar p="md" w={220}>
      <Stack gap={4}>
        <Link to="/" style={{ textDecoration: "none", marginBottom: 12 }}>
          <img src={logoUrl} alt={config.systemName} style={{ width: "100%", objectFit: "contain" }} />
        </Link>
        {navegadorGeofinanceiroActive && (
          <NavLink
            component={Link}
            to="/navegador-geofinanceiro"
            label={navegadorGeofinanceiroAbaName || "Navegador"}
            leftSection={<IconMap size={16} />}
            active={p.startsWith("/navegador-geofinanceiro") || p === "/"}
          />
        )}
        {logradouroActive && (
          <NavLink
            component={Link}
            to="/logradouro"
            label={logradouroAbaName || "Logradouros"}
            leftSection={<IconRoad size={16} />}
            active={p.startsWith("/logradouro")}
          />
        )}
        {arquivosDigitalizadosActive && (
          <NavLink
            component={Link}
            to="/arquivos-digitalizados"
            label={arquivosDigitalizadosAbaName || "Arquivos Digitalizados"}
            leftSection={<IconFiles size={16} />}
            active={p.startsWith("/arquivos-digitalizados")}
          />
        )}
        {arquivosGeraisActive && (
          <NavLink
            component={Link}
            to="/arquivos-gerais-financas"
            label={arquivosGeraisAbaName || "Arquivos Gerais"}
            leftSection={<IconFolderOpen size={16} />}
            active={p.startsWith("/arquivos-gerais-financas")}
          />
        )}
      </Stack>
    </AppShell.Navbar>
  );
}

function PublicFooter() {
  const config = useSelector((state: any) => state.container.config);
  const currentVersion = useSelector((state: any) => state.container.currentVersion);

  if (!config) return null;

  return (
    <AppShell.Footer p="xs">
      <Text size="xs" c="dimmed" ta="center">
        {config.systemName}{currentVersion ? ` ${currentVersion}` : ""} &copy; {config.systemFooterText}
        {config.systemFinanceSyncLastDate && (
          <> &mdash; Última consolidação: {config.systemFinanceSyncLastDate}</>
        )}
      </Text>
    </AppShell.Footer>
  );
}

export default function PublicLayout() {
  const publicSettings = useSelector((state: any) => state.publicSettings.settings);
  const hasNavbar = publicSettings?.opcaoExibicaoMenu === "[LATERAL]";
  const hasHeader = publicSettings?.opcaoExibicaoMenu === "[ABA]";

  return (
    <AppShell
      header={hasHeader ? { height: 56 } : undefined}
      navbar={hasNavbar ? { width: 220, breakpoint: "sm" } : undefined}
      footer={{ height: 40 }}
      padding="md"
    >
      {hasHeader && <PublicHeader />}
      {hasNavbar && <PublicNavbar />}
      <AppShell.Main>
        <Outlet />
      </AppShell.Main>
      <PublicFooter />
    </AppShell>
  );
}
